module.exports = __webpack_public_path__ + "img/down_slider_main.ce65f33f.jpg";